const LOCALHOST_BASE_URL = "http://localhost:3001";
const PRODUCTION_BASE_URL = "https://matrisakhi-admin-prod-api.metafic.co";

// export default LOCALHOST_BASE_URL;
export default PRODUCTION_BASE_URL;